import GitLab from "@/clients/gitlab";
import {GitLabGroup, GitLabProject} from "@/interfaces/gitlab";
import {Config} from "@/interfaces";

class ConfigService {
    private gitlab: GitLab;

    constructor(gitlab: GitLab) {
        this.gitlab = gitlab;
    }

    public async loadProjects(config: Config): Promise<GitLabProject[]> {
        const groups = await this.getGroupsFromConfig(config.groups)
        const groupProjects = await this.getGroupsProjects(groups, config.include_shared_projects)
        const userProjects = await this.getProjectsFromConfig(config.projects)

        let projects = groupProjects.concat(userProjects).flatMap((a) => a)

        // deduplicate projects
        const project_id_map = new Map<number, GitLabProject>()
        projects.map(p => {
            project_id_map.set(p.id, p)
        })
        projects = Array.from(project_id_map.values())

        return projects
    }

    private async getGroupsFromConfig(names: string) {
        const splitNames = this.splitNames(names)
        const groups = await Promise.all(splitNames.map((name: string) => {
            return this.gitlab.searchGroups(name)
        }))
        return groups.flatMap((a) => a)
    }

    private async getGroupsProjects(groups: GitLabGroup[], include_shared_projects: boolean) {
        const projects = await Promise.all(groups.map((group) => {
            return this.gitlab.getAllProjects(group.id, include_shared_projects, {simple: true})
        }))
        return projects.flatMap((a) => a)
    }

    private async getProjectsFromConfig(names: string) {
        const splitNames = this.splitNames(names)
        const projects = await Promise.all(splitNames.map((name: string) => {
            return this.gitlab.searchProjects(name)
        }))
        return projects.flatMap((a) => a)
    }

    private splitNames(names: string) {
        return names.split(';')
            .map((part) => part.trim())
            .filter((part) => part !== '')
    }
}

export default ConfigService